/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.health.concerns'},
});

const ConcernsItem = () => (
  <RouteLinkItem
    route="midas/settings/health/concerns"
    title={messages.title}
  />
);

export default ConcernsItem;
